import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {retailerT} from '@/lib/types/retailer.types';

interface RETAILER_STATE {
  retailers: retailerT[];
  isLoading?: boolean;
  error?: string;
}

const RETAILER_INITIAL: RETAILER_STATE = {
  retailers: [],
};

const retailerSlice = createSlice({
  name: 'retailer',
  initialState: RETAILER_INITIAL,
  reducers: {
    RETAILER_UPDATE: (
      state,
      action: PayloadAction<{
        data?: Partial<RETAILER_STATE>;
        prop?: keyof RETAILER_STATE;
        value?: any;
      }>
    ) => {
      if (action.payload.data) {
        Object.entries(action.payload.data).forEach(([key, value]) => {
          if (key in state) {
            (state as any)[key] = value;
          }
        });
        return state;
      }

      if (action.payload.prop && action.payload.value !== undefined) {
        const prop = action.payload.prop;

        // Narrow the assignment to only properties that exist on the state
        if (prop in state) {
          (state as any)[prop] = action.payload.value;
        }
      }

      return state;
    },
  },
});

const {RETAILER_UPDATE} = retailerSlice.actions;

export {retailerSlice, RETAILER_INITIAL, RETAILER_UPDATE};
